import './App.css';

import { useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Home from './pages/Home';
import Biography from './pages/Biography';
import Videos from './pages/Videos';
import Events from './pages/Events';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

import Footer from './components/Footer';
import Navbar from './components/Navbar';

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
   window.history.scrollRestoration = 'manual';
}

function App() {
   const location = useLocation();

   // Scroll to top on page navigation (instant, not smooth, to avoid
   // being clamped/cancelled by an in-flight smooth-scroll animation)
   useLayoutEffect(() => {
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      // 일부 iOS 버전은 behavior:'instant' 미지원 → 위 인라인 auto가 보장. 안전하게 한 번 더:
      window.scrollTo(0, 0);
      html.style.scrollBehavior = prev;

      // 진행 중인 smooth 스크롤 애니메이션이 위 즉시 이동을 덮어쓸 수 있어,
      // 다음 2프레임에서 scrollY가 0이 아니면 scrollBehavior를 auto로 강제하고 재보정.
      let raf1 = 0;
      let raf2 = 0;
      raf1 = requestAnimationFrame(() => {
         if (window.scrollY !== 0) {
            html.style.scrollBehavior = 'auto';
            window.scrollTo(0, 0);
         }
         raf2 = requestAnimationFrame(() => {
            if (window.scrollY !== 0) {
               html.style.scrollBehavior = 'auto';
               window.scrollTo(0, 0);
            }
         });
      });

      return () => {
         cancelAnimationFrame(raf1);
         cancelAnimationFrame(raf2);
      };
   }, [location.pathname]);

   const username = 'Yera Kim';
   const urls = {
      youtube: 'https://youtube.com/@yerakim3956',
      instagram: 'https://instagram.com/ye___ra?igshid=MzRlODBiNWFlZA==',
   };
   const footerMessage = `© ${new Date().getFullYear()} ${username}. All rights reserved.`;

   const isHomePage = location.pathname === '/';
   const isAdminPage = location.pathname === '/admin';

   return (
      <div className="App">
         {!isAdminPage && <Navbar username={username} />}
         <main className="main-content">
            <AnimatePresence mode="wait">
               <Routes location={location} key={location.pathname}>
                  <Route index element={<Home />} />
                  <Route path="/biography" element={<Biography />} />
                  <Route path="/videos" element={<Videos />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/contact" element={<Contact urls={urls} />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<Home />} />
               </Routes>
            </AnimatePresence>
         </main>
         {!isHomePage && !isAdminPage && <Footer message={footerMessage} urls={urls} />}
      </div>
   );
}

export default App;
